<template>
  <div class="modal-mask" @click.self="cancel">
    <div class="modal">
      <div class="head">
        <h4>{{ mode==='add' ? '센터 추가' : '센터장 설정' }}</h4>
        <div class="head-btns">
          <button class="primary" :disabled="busy" @click="save">저장</button>
          <button class="ghost" @click="cancel">취소</button>
        </div>
      </div>

      <!-- 센터명 : 센터 추가=활성 에디트 / 센터장 설정=비활성(20010, 센터 검색 버튼 제거) -->
      <div class="row">
        <label>센터명</label>
        <input v-model="centerName" type="text" placeholder="센터명" :disabled="mode==='leader'" />
      </div>

      <!-- 센터장 : 센터장 설정 모드에서만 표시. 비활성 + 회원 검색(해당 센터 소속 회원만) -->
      <div v-if="mode==='leader'" class="row">
        <label>센터장</label>
        <input :value="leaderName" type="text" disabled placeholder="센터장(회원 검색)" />
        <button class="srch" @click="memberSearchOpen=true">검색</button>
      </div>

      <p v-if="message" class="error">{{ message }}</p>
    </div>

    <!-- 20009: 센터장 설정 회원 검색은 해당 센터 소속 회원만(centerId 스코프) -->
    <SettlementMemberSearchDialog v-if="memberSearchOpen" :center-id="id"
                                  @select="onPickMember" @close="memberSearchOpen=false" />
  </div>
</template>

<script>
import api from '../api';
import SettlementMemberSearchDialog from './SettlementMemberSearchDialog.vue';

export default {
  name: 'CenterFormDialog',
  components: { SettlementMemberSearchDialog },
  props: {
    mode: { type: String, default: 'add' },     // 'add'(센터 추가) | 'leader'(센터장 설정)
    center: { type: Object, default: null }      // 센터장 설정 대상 row
  },
  data() {
    return {
      id: this.center ? this.center.id : null,
      centerName: this.center ? this.center.centerName : '',
      leaderCustomerId: this.center ? this.center.leaderCustomerId : null,
      leaderName: this.center ? (this.center.leaderName || '') : '',
      memberSearchOpen: false,
      busy: false, message: ''
    };
  },
  methods: {
    onPickMember(m) { this.leaderCustomerId = m.id; this.leaderName = m.name; this.memberSearchOpen = false; },
    async save() {
      this.message = '';
      if (!this.centerName || !this.centerName.trim()) { this.message = '센터명을 입력하세요.'; return; }
      this.busy = true;
      try {
        let res;
        if (this.mode === 'add') {
          res = await api.centerAdminAdd({ centerName: this.centerName.trim() });
        } else {
          res = await api.centerAdminUpdate({ id: this.id, centerName: this.centerName.trim(), leaderCustomerId: this.leaderCustomerId });
        }
        const data = res.data || {};
        if (data.success === false) { this.message = res.message || '저장할 수 없습니다.'; return; }
        this.$emit('saved');
      } catch (e) { this.message = e.message; }
      finally { this.busy = false; }
    },
    cancel() { this.$emit('close'); }
  }
};
</script>

<style scoped>
.modal-mask { position: fixed; inset: 0; background: rgba(0,0,0,.4); display: flex; align-items: center; justify-content: center; z-index: 75; }
.modal { background: #fff; padding: 20px 22px; border-radius: 8px; width: 440px; max-width: 94vw; }
.head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 14px; }
.head h4 { margin: 0; }
.head-btns button { padding: 7px 14px; border-radius: 6px; cursor: pointer; border: 1px solid #ccc; margin-left: 6px; }
.head-btns .primary { background: #2f6fed; color: #fff; border-color: #2f6fed; }
.head-btns .ghost { background: #f5f5f5; }
.row { display: flex; align-items: center; gap: 8px; margin: 10px 0; }
.row label { width: 60px; font-size: 13px; color: #555; }
.row input { flex: 1; padding: 8px; border: 1px solid #d0d5dd; border-radius: 6px; }
.row input:disabled { background: #f2f4f7; color: #667085; }
.srch { padding: 7px 12px; border: 1px solid #2f6fed; background: #eef4ff; color: #2f5fd0; border-radius: 6px; cursor: pointer; font-size: 12px; }
.error { color: #d93636; font-size: 13px; margin: 8px 0 0; }
</style>
